var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card lcs-product" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [_vm._v("Product")]),
              _vm._v(" "),
              _c("multiselect", {
                class: {
                  "is-invalid":
                    _vm.errors.product || _vm.errors.product_restriction
                },
                attrs: {
                  id: "site",
                  label: "name",
                  "track-by": "id",
                  options: _vm.departments,
                  "group-label": "department",
                  "group-values": "products"
                },
                model: {
                  value: _vm.detail.data.product,
                  callback: function($$v) {
                    _vm.$set(_vm.detail.data, "product", $$v)
                  },
                  expression: "detail.data.product"
                }
              }),
              _vm._v(" "),
              _vm.errors.tat
                ? _c("div", { staticClass: "invalid-feedback" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.errors.tat) +
                        "\n                    "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.errors.product_restriction
                ? _c("div", { staticClass: "invalid-feedback" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.errors.product_restriction) +
                        "\n                    "
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm.isFirstDrawInspection || _vm.isNextDrawInspection
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12 mb-2" }, [
              _c("div", { staticClass: "form-check" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.detail.data.is_active_request,
                      expression: "detail.data.is_active_request"
                    }
                  ],
                  staticClass: "form-check-input",
                  class: {
                    "is-invalid": _vm.errors && _vm.errors["is_active_request"]
                  },
                  attrs: {
                    id: "is-active-request",
                    type: "checkbox",
                    "true-value": "Yes",
                    "false-value": "No"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.detail.data.is_active_request)
                      ? _vm._i(_vm.detail.data.is_active_request, null) > -1
                      : _vm._q(_vm.detail.data.is_active_request, "Yes")
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.detail.data.is_active_request,
                        $$el = $event.target,
                        $$c = $$el.checked ? "Yes" : "No"
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.detail.data,
                              "is_active_request",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.detail.data,
                              "is_active_request",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.detail.data, "is_active_request", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label",
                    attrs: { for: "is-active-request" }
                  },
                  [
                    _vm._v(
                      "\n                        Check this box if this is a currently active request.\n                    "
                    )
                  ]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isEvansBankAppraisal && _vm.canSelectAppraisers
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "appraisers" } }, [
                    _vm._v("Please select up to 5 appraisers.")
                  ]),
                  _vm._v(" "),
                  _c("multiselect", {
                    class: { "is-invalid": _vm.errors.appraisers },
                    attrs: {
                      id: "appraisers",
                      max: 5,
                      label: "name",
                      "track-by": "id",
                      options: _vm.appraisers,
                      multiple: true
                    },
                    model: {
                      value: _vm.detail.data.appraisers,
                      callback: function($$v) {
                        _vm.$set(_vm.detail.data, "appraisers", $$v)
                      },
                      expression: "detail.data.appraisers"
                    }
                  }),
                  _vm._v(" "),
                  _vm.errors.appraisers
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.errors.appraisers) +
                            "\n                    "
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          !_vm.isEvansBankAppraisal
            ? [
                _c("div", { staticClass: "col-md-3 col-sm-6" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Turn Around Time")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.detail.data.tat,
                            expression: "detail.data.tat"
                          }
                        ],
                        staticClass: "form-control",
                        class: { "is-invalid": _vm.errors.tat },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.detail.data,
                              "tat",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      _vm._l(_vm.tats, function(tat) {
                        return _c(
                          "option",
                          { domProps: { value: tat.value } },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(tat.text) +
                                "\n                            "
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.errors.tat
                      ? _c("div", { staticClass: "invalid-feedback" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.errors.tat) +
                              "\n                        "
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          !_vm.isEvansBankAppraisal && _vm.isAdmin
            ? [
                _c("div", { staticClass: "col-md-4 col-sm-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", [_vm._v("Target Completion Date")]),
                      _vm._v(" "),
                      _c("date-picker", {
                        attrs: {
                          format: "MM/DD/YYYY",
                          "value-type": "YYYY-MM-DD"
                        },
                        model: {
                          value: _vm.eta,
                          callback: function($$v) {
                            _vm.eta = $$v
                          },
                          expression: "eta"
                        }
                      }),
                      _vm._v(" "),
                      _vm.errors.eta
                        ? _c(
                            "div",
                            { staticClass: "invalid-feedback d-block" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.errors.eta) +
                                  "\n                        "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          !_vm.isEvansBankAppraisal
            ? [
                _c("div", { staticClass: "col-md-4 col-sm-6" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [
                      _vm._v("Target Completion Date Upon Acceptance of Award")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.eta,
                          expression: "eta"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", readonly: "" },
                      domProps: { value: _vm.eta },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.eta = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.eta
                      ? _c("div", { staticClass: "invalid-feedback d-block" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.errors.eta) +
                              "\n                        "
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-5 col-sm-6" }, [
                  _vm._v("\n                     \n                ")
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isAdmin
            ? [
                _c("div", { staticClass: "col-md-3 col-sm-6" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "fees" } }, [_vm._v("Fees")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.fees,
                          expression: "fees"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { id: "fees", type: "number" },
                      domProps: { value: _vm.fees },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.fees = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.hasCerclaFlag
            ? _c("div", { staticClass: "col-md-2" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("CERCLA Protection")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.detail.data.cercla,
                          expression: "detail.data.cercla"
                        }
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.errors.cercla },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.detail.data,
                            "cercla",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "Yes" } }, [
                        _vm._v(
                          "\n                            Yes\n                        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "No" } }, [
                        _vm._v(
                          "\n                            No\n                        "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.errors.cercla
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.errors.cercla) +
                            "\n                    "
                        )
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasLienFlag
            ? _c("div", { staticClass: "col-md-2" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Lien Search")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.detail.data.lien,
                          expression: "detail.data.lien"
                        }
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.errors.lien },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.detail.data,
                            "lien",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "Yes" } }, [
                        _vm._v(
                          "\n                            Yes\n                        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "No" } }, [
                        _vm._v(
                          "\n                            No\n                        "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.errors.lien
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.errors.lien) +
                            "\n                    "
                        )
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasSbaFlag
            ? _c("div", { staticClass: "col-md-2" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("SBA Loan")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.detail.data.sba,
                          expression: "detail.data.sba"
                        }
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.errors.sba },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.detail.data,
                            "sba",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "Yes" } }, [
                        _vm._v(
                          "\n                            Yes\n                        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "No" } }, [
                        _vm._v(
                          "\n                            No\n                        "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.errors.sba
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.errors.sba) +
                            "\n                    "
                        )
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoofFlag
            ? _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "form-check" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.detail.data.roof,
                          expression: "detail.data.roof"
                        }
                      ],
                      staticClass: "form-check-input",
                      class: { "is-invalid": _vm.errors.roof },
                      attrs: {
                        id: "roof_" + _vm._uid,
                        type: "checkbox",
                        "true-value": "Yes",
                        "false-value": "No"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.detail.data.roof)
                          ? _vm._i(_vm.detail.data.roof, null) > -1
                          : _vm._q(_vm.detail.data.roof, "Yes")
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.detail.data.roof,
                            $$el = $event.target,
                            $$c = $$el.checked ? "Yes" : "No"
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.detail.data,
                                  "roof",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.detail.data,
                                  "roof",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.detail.data, "roof", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "roof_" + _vm._uid }
                      },
                      [
                        _vm._v(
                          "\n                            I acknowledge that in order to complete the service selected, roof access must be provided on the selected site.\n                        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.errors.roof
                      ? _c("div", { staticClass: "invalid-feedback" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.errors.roof) +
                              "\n                        "
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasValuationFlag
            ? _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c("fields-valuation", {
                    attrs: {
                      "property-type": _vm.detail.data.propertyType,
                      "transaction-amount": _vm.detail.data.transactionAmount,
                      "transaction-other": _vm.detail.data.transactionTypeOther,
                      transaction: _vm.detail.data.transactionType,
                      "interest-other": _vm.detail.data.interestAppraisedOther,
                      interest: _vm.detail.data.interestAppraised,
                      complexity: _vm.detail.data.complexity,
                      errors: _vm.errors
                    },
                    on: {
                      propertyType: function($event) {
                        _vm.detail.data.propertyType = $event
                      },
                      transactionAmount: function($event) {
                        _vm.detail.data.transactionAmount = $event
                      },
                      transactionOther: function($event) {
                        _vm.detail.data.transactionTypeOther = $event
                      },
                      transaction: function($event) {
                        _vm.detail.data.transactionType = $event
                      },
                      interestOther: function($event) {
                        _vm.detail.data.interestAppraisedOther = $event
                      },
                      interest: function($event) {
                        _vm.detail.data.interestAppraised = $event
                      },
                      complexity: function($event) {
                        _vm.detail.data.complexity = $event
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isEvansBankAppraisal
            ? _c("div", { staticClass: "col-md-6 mb-3" }, [
                _c("p", { staticClass: "font-weight-bold mb-1" }, [
                  _vm._v("Sub Products Selected:")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.detail.data.sub_products_selected,
                        expression: "detail.data.sub_products_selected"
                      }
                    ],
                    staticClass: "form-check-input",
                    class: {
                      "is-invalid":
                        _vm.errors && _vm.errors["sub_products_selected.*"]
                    },
                    attrs: {
                      id: "subprod_" + _vm._uid + "_18",
                      type: "checkbox",
                      value: "Property Condition Assessment"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.detail.data.sub_products_selected
                      )
                        ? _vm._i(
                            _vm.detail.data.sub_products_selected,
                            "Property Condition Assessment"
                          ) > -1
                        : _vm.detail.data.sub_products_selected
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.detail.data.sub_products_selected,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "Property Condition Assessment",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.detail.data,
                                "sub_products_selected",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.detail.data,
                                "sub_products_selected",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.detail.data,
                            "sub_products_selected",
                            $$c
                          )
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "subprod_" + _vm._uid + "_18" }
                    },
                    [
                      _vm._v(
                        "\n                        Property Condition Assessment\n                    "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.detail.data.sub_products_selected,
                        expression: "detail.data.sub_products_selected"
                      }
                    ],
                    staticClass: "form-check-input",
                    class: {
                      "is-invalid":
                        _vm.errors && _vm.errors["sub_products_selected.*"]
                    },
                    attrs: {
                      id: "subprod_" + _vm._uid + "_74",
                      type: "checkbox",
                      value: "Transaction Screen"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.detail.data.sub_products_selected
                      )
                        ? _vm._i(
                            _vm.detail.data.sub_products_selected,
                            "Transaction Screen"
                          ) > -1
                        : _vm.detail.data.sub_products_selected
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.detail.data.sub_products_selected,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "Transaction Screen",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.detail.data,
                                "sub_products_selected",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.detail.data,
                                "sub_products_selected",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.detail.data,
                            "sub_products_selected",
                            $$c
                          )
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "subprod_" + _vm._uid + "_74" }
                    },
                    [
                      _vm._v(
                        "\n                        Transaction Screen\n                    "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.detail.data.sub_products_selected,
                        expression: "detail.data.sub_products_selected"
                      }
                    ],
                    staticClass: "form-check-input",
                    class: {
                      "is-invalid":
                        _vm.errors && _vm.errors["sub_products_selected.*"]
                    },
                    attrs: {
                      id: "subprod_" + _vm._uid + "_79",
                      type: "checkbox",
                      value: "Phase I Environmental Site Assessment"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.detail.data.sub_products_selected
                      )
                        ? _vm._i(
                            _vm.detail.data.sub_products_selected,
                            "Phase I Environmental Site Assessment"
                          ) > -1
                        : _vm.detail.data.sub_products_selected
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.detail.data.sub_products_selected,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "Phase I Environmental Site Assessment",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.detail.data,
                                "sub_products_selected",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.detail.data,
                                "sub_products_selected",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.detail.data,
                            "sub_products_selected",
                            $$c
                          )
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "subprod_" + _vm._uid + "_79" }
                    },
                    [
                      _vm._v(
                        "\n                        Phase I Environmental Site Assessment\n                    "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.detail.data.sub_products_selected,
                        expression: "detail.data.sub_products_selected"
                      }
                    ],
                    staticClass: "form-check-input",
                    class: {
                      "is-invalid":
                        _vm.errors && _vm.errors["sub_products_selected.*"]
                    },
                    attrs: {
                      id: "subprod_" + _vm._uid + "_88",
                      type: "checkbox",
                      value: "Residential Appraisal"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.detail.data.sub_products_selected
                      )
                        ? _vm._i(
                            _vm.detail.data.sub_products_selected,
                            "Residential Appraisal"
                          ) > -1
                        : _vm.detail.data.sub_products_selected
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.detail.data.sub_products_selected,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "Residential Appraisal",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.detail.data,
                                "sub_products_selected",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.detail.data,
                                "sub_products_selected",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.detail.data,
                            "sub_products_selected",
                            $$c
                          )
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "subprod_" + _vm._uid + "_88" }
                    },
                    [
                      _vm._v(
                        "\n                        Residential Appraisal\n                    "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.detail.data.sub_products_selected,
                        expression: "detail.data.sub_products_selected"
                      }
                    ],
                    staticClass: "form-check-input",
                    class: {
                      "is-invalid":
                        _vm.errors && _vm.errors["sub_products_selected.*"]
                    },
                    attrs: {
                      id: "subprod_" + _vm._uid + "_89",
                      type: "checkbox",
                      value: "Commercial Appraisal"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.detail.data.sub_products_selected
                      )
                        ? _vm._i(
                            _vm.detail.data.sub_products_selected,
                            "Commercial Appraisal"
                          ) > -1
                        : _vm.detail.data.sub_products_selected
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.detail.data.sub_products_selected,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "Commercial Appraisal",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.detail.data,
                                "sub_products_selected",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.detail.data,
                                "sub_products_selected",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.detail.data,
                            "sub_products_selected",
                            $$c
                          )
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "subprod_" + _vm._uid + "_89" }
                    },
                    [
                      _vm._v(
                        "\n                        Commercial Appraisal\n                    "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.detail.data.sub_products_selected,
                        expression: "detail.data.sub_products_selected"
                      }
                    ],
                    staticClass: "form-check-input",
                    class: {
                      "is-invalid":
                        _vm.errors && _vm.errors["sub_products_selected.*"]
                    },
                    attrs: {
                      id: "subprod_" + _vm._uid + "_other",
                      type: "checkbox",
                      value: "Other"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.detail.data.sub_products_selected
                      )
                        ? _vm._i(
                            _vm.detail.data.sub_products_selected,
                            "Other"
                          ) > -1
                        : _vm.detail.data.sub_products_selected
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.detail.data.sub_products_selected,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "Other",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.detail.data,
                                "sub_products_selected",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.detail.data,
                                "sub_products_selected",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.detail.data,
                            "sub_products_selected",
                            $$c
                          )
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "subprod_" + _vm._uid + "_89" }
                    },
                    [_vm._v("\n                    Other\n                  ")]
                  )
                ]),
                _vm._v(" "),
                _vm.errors && _vm.errors["sub_products_selected.*"]
                  ? _c("div", { staticClass: "invalid-feedback d-block" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.errors["sub_products_selected.*"]) +
                          "\n                "
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-12" }, [
            _c(
              "div",
              { staticClass: "form-group mb-0" },
              [
                _c("label", [_vm._v("Special Order Notes")]),
                _vm._v(" "),
                _c("wysiwyg", {
                  class: { "is-invalid": _vm.errors.notes },
                  model: {
                    value: _vm.detail.data.notes,
                    callback: function($$v) {
                      _vm.$set(_vm.detail.data, "notes", $$v)
                    },
                    expression: "detail.data.notes"
                  }
                }),
                _vm._v(" "),
                _vm.errors.notes
                  ? _c("div", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.errors.notes) +
                          "\n                    "
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-footer" }, [
      _c("div", { staticClass: "d-flex justify-content-end" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-danger",
            on: {
              click: function($event) {
                return _vm.$emit("delete", _vm.detail)
              }
            }
          },
          [_vm._v("\n                Delete\n            ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }